import * as React from "react";
const SvgLogoGray200 = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={40} height={40} fill="none" {...props}>
    <path
      fill="#DEDEDE"
      d="M30.04 11.115a4.96 4.96 0 0 0-4.879 4.054.085.085 0 0 1-.083.069.08.08 0 0 1-.08-.069 5.08 5.08 0 0 0-9.996 0 .08.08 0 0 1-.08.069.085.085 0 0 1-.083-.069A4.96 4.96 0 0 0 5 16.076c0 5.418 6.563 8.48 9.922 13.766 1.377-2.174 3.297-3.97 5.078-5.708 1.783 1.739 3.7 3.534 5.078 5.708C28.438 24.542 35 21.48 35 16.076a4.96 4.96 0 0 0-4.96-4.96"
    />
  </svg>
);
export default SvgLogoGray200;
